import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { handleValidationErrors } from "../../../util/format";

///////////////////////////////////////////
// Main Component used to display message//
///////////////////////////////////////////

class DisplayMessage extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { serverValidation, input, actions, changeTargetUUID } = this.props;
    const { AssayDesign } = serverValidation;
    const { ApplicationType } = AssayDesign || {};
    const isErrorNotFound = (serverValidation) => {
      return (
        !_.isEmpty(serverValidation.Errors) &&
        _.has(serverValidation, "AssayDesign") &&
        _.isEmpty(serverValidation.Targets)
      );
    };

    const isAnAlias = (serverValidation) => {
      return (
        !_.isEmpty(serverValidation.Errors) &&
        _.has(serverValidation, "AssayDesign") &&
        !_.isEmpty(serverValidation.Targets)
      );
    };
    return (
      <div className="form-error validation">
        {isErrorNotFound(serverValidation) &&
          serverValidation.Errors[0].Text &&
          serverValidation.Errors[0].Code && (
            <DisplayFailMessage
              failedReason={
                handleValidationErrors(serverValidation.Errors[0].Code) ||
                serverValidation.Errors[0].Text
              }
            />
          )}
        {isAnAlias(serverValidation) &&
          serverValidation.Errors[0].Code &&
          serverValidation.Errors[0].Text &&
          !_.isEmpty(serverValidation.Targets) &&
          ApplicationType && (
            <DisplayWarningMessage
              applicationType={ApplicationType || ""}
              targets={serverValidation.Targets || {}}
              input={input}
              failedReason={
                handleValidationErrors(serverValidation.Errors[0].Code) ||
                serverValidation.Errors[0].Text
              }
              actions={actions}
              changeTargetUUID={changeTargetUUID}
            />
          )}
      </div>
    );
  }
}
export default DisplayMessage;

// Sub-Component used in `DisplayMessage` for displaying
// errors (invalid inputs) from the valiation API endpoint
const DisplayFailMessage = ({ failedReason }) => (
  <div className="fail-message">
    <span>{failedReason}</span>
  </div>
);

// Sub-Component used in `DisplayMessage` for displaying
// the warning message from the validation API end point.
// It may contain official Gene Symbols or Identifiers [single element or an array]
// which needs to clickable.
const DisplayWarningMessage = ({
  targets,
  input,
  failedReason,
  applicationType,
  actions,
  changeTargetUUID,
}) => (
  <div className="fail-message warning-message">
    <span>{failedReason}</span>
    <br />
    <span className="support-text">Did you mean:</span>
    <br />
    {!_.isEmpty(targets) && targets && (
      <DisplayMessageList
        applicationType={applicationType}
        targets={targets}
        input={input}
        actions={actions}
        changeTargetUUID={changeTargetUUID}
      />
    )}
  </div>
);

// Sub-Component used in `DisplayWarningMessage` for displaying array of
const DisplayMessageList = ({
  targets,
  input,
  applicationType,
  actions,
  changeTargetUUID,
}) => {
  return (
    <ul className="warning-list">
      {targets.map((target, k) => (
        <li key={k}>
          <WarningMessage
            officialGeneSymbol={target.Name}
            input={input}
            cosmicId={target.CosmicId}
            geneName={target.Gene.Name}
            applicationType={applicationType}
            targetUUID={target.Uuid}
            actions={actions}
            changeTargetUUID={changeTargetUUID}
          />
        </li>
      ))}
    </ul>
  );
};

// Sub-Component used in `DisplayWarningMessage` and `DisplayMessageList` for displaying basic warning string
// This component is iterated if there is an array of suggestions
const WarningMessage = ({
  officialGeneSymbol,
  input,
  cosmicId,
  applicationType,
  geneName,
  targetUUID,
  changeTargetUUID,
}) => (
  <a
    className="warning"
    style={{ color: "#ced4da" }}
    onClick={() => {
      input.onChange(officialGeneSymbol);
      if (targetUUID !== "") {
        changeTargetUUID(targetUUID);
      }
    }}
  >
    {applicationType !== "MutationDetection" && (
      <span style={{ fontStyle: "italic" }}>
        {officialGeneSymbol}-{geneName}
      </span>
    )}
    {applicationType === "MutationDetection" && (
      <span style={{ fontStyle: "italic" }}>
        {cosmicId}
        {"-"}
        {officialGeneSymbol}
      </span>
    )}
  </a>
);

// PropTypes Validation for the above Components
DisplayFailMessage.propTypes = {
  failedReason: PropTypes.string,
}; //DisplayFailMessage

DisplayWarningMessage.propTypes = WarningMessage.propTypes = DisplayMessageList.propTypes = {
  officialGeneSymbol: PropTypes.string,
  changeTargetUUID: PropTypes.string,
  input: PropTypes.object,
}; //DisplayWarningMessage && WarningMessage && DisplayMessageList

DisplayMessageList.propTypes = {
  actions: PropTypes.object,
  targets: PropTypes.object,
  applicationType: PropTypes.object,
};

DisplayMessage.propTypes = {
  targets: PropTypes.object,
  actions: PropTypes.object,
  serverValidation: PropTypes.object,
  changeTargetUUID: PropTypes.string,
  input: PropTypes.object,
}; //DisplayMessage
